import React from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tab,
  Tabs,
  Divider,
  Typography,
  FormControlLabel,
} from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormLabel from "@material-ui/core/FormLabel";
import { Field } from "formik";
import moment from "moment-timezone";
import { useStyles } from "../campaignModalStyles";
import { i18n } from "../../../translate/i18n";
import { getProviderLabel } from "../../../constants/aiProviderCatalog";
import { getCampaignTimezoneSync } from "../../../helpers/getCampaignTimezone";
import DateTimePickerWithTimezone from "../../FormFields/DateTimePickerWithTimezone";

const CampaignFormHeader = ({
  // Formik
  values,
  setFieldValue,
  errors,
  touched,
  // Collections
  promptsList,
  contactLists,
  whatsapps,
  tagLists,
  fileLists,
  selectedContactListCount,
  // Campaign config
  campaignId,
  campaignEditable,
  campaignAiChoice,
  companyTimezone,
  currentCampaignType,
  isAttachmentSelected,
  // Tab state
  configTab,
  setConfigTab,
  // Refs
  lastWrittenNameRef,
  // Parent state callbacks
  setCampaign,
  errorMessage,
  setErrorMessage,
  setErrorModalOpen,
  setCampaignAiChoice,
  setMessageTab,
  // Alert modal setters
  setDatePastMessage,
  setPendingSetFieldValue,
  setDatePastModalOpen,
  setShortTimeMessage,
  setPendingScheduledAt,
  setShortTimeModalOpen,
  // Handlers
  handleContactListChange,
  handleTagListChange,
  handleFileListChange,
}) => {
  const classes = useStyles();

  return (
    <>
      <Grid xs={12} md={campaignAiChoice === "yes" ? 6 : 12} item>
        <TextField
          label={
            <span>
              <span role="img" aria-label="Nombre de campaña">📝</span> {i18n.t("campaigns.dialog.form.name")}
            </span>
          }
          name="name"
          value={values.name || ""}
          onChange={(e) => {
            const value = e.target.value;
            // Limitar a 40 caracteres en tiempo real
            if (value.length <= 40) {
              // ✅ CRÍTICO: Guardar el último valor escrito en el ref (fuente de verdad)
              lastWrittenNameRef.current = value;

              // ✅ CRÍTICO: Actualizar tanto Formik como el estado campaign para mantener sincronización
              setFieldValue('name', value);
              setCampaign((prev) => ({ ...prev, name: value }));
              // ✅ CORRECCIÓN: Limpiar error de nombre duplicado cuando el usuario cambia el nombre
              if (errorMessage && (errorMessage.includes("nombre de campaña") || errorMessage.includes("ya existe"))) {
                setErrorMessage("");
                setErrorModalOpen(false);
              }
            }
          }}
          error={touched.name && Boolean(errors.name)}
          helperText={touched.name && errors.name ? errors.name : ""}
          variant="outlined"
          margin="dense"
          fullWidth
          className={classes.textField}
          disabled={!campaignEditable}
          inputProps={{
            maxLength: 40,
            minLength: 3
          }}
        />
      </Grid>
      {campaignAiChoice === "yes" && (
        <Grid xs={12} md={6} item>
          <FormControl
            variant="outlined"
            margin="dense"
            fullWidth
            className={`${classes.formControl} ${classes.selectField}`}
            error={touched.promptId && Boolean(errors.promptId)}
            disabled={!campaignEditable}
          >
            <InputLabel id="campaign-prompt-send-label" style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <span role="img" aria-hidden>
                ✨
              </span>
              {i18n.t("campaigns.dialog.ai.promptAgentSend")}
            </InputLabel>
            <Select
              labelId="campaign-prompt-send-label"
              id="campaign-prompt-send-select"
              value={values.promptId === null || values.promptId === undefined ? "" : values.promptId}
              onChange={(e) => {
                const v = e.target.value;
                setFieldValue("promptId", v === "" ? "" : Number(v));
              }}
              label={i18n.t("campaigns.dialog.ai.promptAgentSend")}
            >
              <MenuItem value="">
                <em>{i18n.t("campaigns.dialog.ai.promptPlaceholderSend")}</em>
              </MenuItem>
              {(promptsList || []).map((p) => (
                <MenuItem key={p.id} value={p.id}>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <span style={{ fontWeight: 600 }}>{p.name}</span>
                    <Typography variant="caption" color="textSecondary">
                      {getProviderLabel(p.provider)}
                    </Typography>
                  </div>
                </MenuItem>
              ))}
            </Select>
            {touched.promptId && errors.promptId ? (
              <Typography variant="caption" color="error" style={{ marginLeft: 14, marginTop: 4 }}>
                {errors.promptId}
              </Typography>
            ) : null}
          </FormControl>
        </Grid>
      )}
      {campaignId && campaignEditable && (
        <Grid xs={12} item>
          <FormLabel component="legend" style={{ marginBottom: 4 }}>
            {i18n.t("campaigns.dialog.ai.modeLabel")}
          </FormLabel>
          <RadioGroup
            row
            value={campaignAiChoice === "yes" ? "yes" : "no"}
            onChange={(e) => {
              const v = e.target.value;
              setCampaignAiChoice(v);
              if (v === "no") {
                setFieldValue("promptId", "");
                setFieldValue("replyPromptId", "");
              } else {
                setFieldValue("autoTagEnabled", true);
                setFieldValue("confirmation", false);
                setFieldValue("promptId", "");
                setFieldValue("replyPromptId", "");
                setMessageTab(0);
              }
            }}
          >
            <FormControlLabel
              value="no"
              control={<Radio color="primary" />}
              label={i18n.t("campaigns.dialog.ai.modeClassic")}
            />
            <FormControlLabel
              value="yes"
              control={<Radio color="primary" />}
              label={i18n.t("campaigns.dialog.ai.modeAi")}
            />
          </RadioGroup>
        </Grid>
      )}
      {/* <Grid xs={12} md={3} item>
        <FormControl
          variant="outlined"
          margin="dense"
          fullWidth
          className={classes.formControl}
        >
          <InputLabel id="confirmation-selection-label">
            {i18n.t("campaigns.dialog.form.confirmation")}
          </InputLabel>
          <Field
            as={Select}
            label={i18n.t("campaigns.dialog.form.confirmation")}
            placeholder={i18n.t(
              "campaigns.dialog.form.confirmation"
            )}
            labelId="confirmation-selection-label"
            id="confirmation"
            name="confirmation"
            error={
              touched.confirmation && Boolean(errors.confirmation)
            }
            disabled={!campaignEditable}
          >
            <MenuItem value={false}>Desabilitada</MenuItem>
            <MenuItem value={true}>Habilitada</MenuItem>
          </Field>
        </FormControl>
      </Grid> */}
      <Grid xs={12} md={4} item>
        <FormControl
          variant="outlined"
          margin="dense"
          fullWidth
          className={`${classes.formControl} ${classes.selectField}`}
        >
          <InputLabel id="contactList-selection-label">
            <span role="img" aria-label="Lista de contactos">📋</span> {i18n.t("campaigns.dialog.form.contactList")}
          </InputLabel>
          <Field
            as={Select}
            label={
              <span>
                <span role="img" aria-label="Lista de contactos">📋</span> {i18n.t("campaigns.dialog.form.contactList")}
              </span>
            }
            placeholder={i18n.t(
              "campaigns.dialog.form.contactList"
            )}
            labelId="contactList-selection-label"
            id="contactListId"
            name="contactListId"
            error={
              touched.contactListId && Boolean(errors.contactListId)
            }
            disabled={Boolean(!campaignEditable || (values.tagListId && values.tagListId !== ""))}
            onChange={(e) => handleContactListChange(e.target.value, setFieldValue)}
          >
            <MenuItem value=""><span role="img" aria-label="No definido">❌</span> {i18n.t("campaigns.placeholders.notDefined")}</MenuItem>
            {contactLists &&
              contactLists.map((contactList) => (
                <MenuItem
                  key={contactList.id}
                  value={contactList.id}
                >
                  <span role="img" aria-label="Contactos">👥</span> {contactList.name}
                </MenuItem>
              ))}
          </Field>
        </FormControl>
      </Grid>
      <Grid xs={12} md={4} item>
        <FormControl
          variant="outlined"
          margin="dense"
          fullWidth
          className={`${classes.formControl} ${classes.selectField}`}
        >
          <InputLabel id="tagList-selection-label">
            <span role="img" aria-label="Lista de etiquetas">🏷️</span> {i18n.t("campaigns.dialog.form.tagList")}
          </InputLabel>
          <Field
            as={Select}
            label={
              <span>
                <span role="img" aria-label="Lista de etiquetas">🏷️</span> {i18n.t("campaigns.dialog.form.tagList")}
              </span>
            }
            placeholder={i18n.t("campaigns.dialog.form.tagList")}
            labelId="tagList-selection-label"
            id="tagListId"
            name="tagListId"
            error={touched.tagListId && Boolean(errors.tagListId)}
            disabled={Boolean(!campaignEditable || (values.contactListId && values.contactListId !== ""))}
            onChange={(e) => handleTagListChange(e.target.value, setFieldValue)}
          >
            <MenuItem value=""><span role="img" aria-label="No definido">❌</span> {i18n.t("campaigns.placeholders.notDefined")}</MenuItem>
            {Array.isArray(tagLists) &&
              tagLists.map((tagList) => (
                <MenuItem key={tagList.id} value={tagList.id}>
                  <span role="img" aria-label="Etiqueta">🏷️</span> {tagList.name}
                </MenuItem>
              ))}
          </Field>
        </FormControl>
      </Grid>
      <Grid xs={12} md={4} item>
        <FormControl
          variant="outlined"
          margin="dense"
          fullWidth
          className={`${classes.formControl} ${classes.selectField}`}
        >
          <InputLabel id="whatsapp-selection-label">
            <span role="img" aria-label="Conexión WhatsApp">📱</span> {i18n.t("campaigns.dialog.form.whatsapp")}
          </InputLabel>
          <Field
            as={Select}
            label={
              <span>
                <span role="img" aria-label="Conexión WhatsApp">📱</span> {i18n.t("campaigns.dialog.form.whatsapp")}
              </span>
            }
            placeholder={i18n.t("campaigns.dialog.form.whatsapp")}
            labelId="whatsapp-selection-label"
            id="whatsappId"
            name="whatsappId"
            error={touched.whatsappId && Boolean(errors.whatsappId)}
            disabled={!campaignEditable}
            renderValue={() => {
              if (!values.whatsappId || values.whatsappId === "") {
                return (
                  <div style={{ display: 'flex', alignItems: 'center', color: '#999' }}>
                    <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                    <span>{i18n.t("campaigns.placeholders.notDefinedMale") || "Seleccione una conexión"}</span>
                  </div>
                );
              }
              const whatsapp = whatsapps?.find(w => w.id === Number(values.whatsappId));
              if (!whatsapp) {
                return (
                  <div style={{ display: 'flex', alignItems: 'center', color: '#999' }}>
                    <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                    <span>{i18n.t("campaigns.placeholders.notDefinedMale") || "Seleccione una conexión"}</span>
                  </div>
                );
              }
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {whatsapp.name || `Conexión ${whatsapp.id}`}
                      </span>
                      <span
                        style={{
                          fontSize: '10px',
                          padding: '2px 6px',
                          borderRadius: '10px',
                          backgroundColor: whatsapp.status === 'CONNECTED' ? '#25d366' : '#e1306c',
                          color: 'white',
                          fontWeight: 'bold'
                        }}
                      >
                        {whatsapp.status || 'DISCONNECTED'}
                      </span>
                    </div>
                    <span style={{ fontSize: '12px', color: '#666' }}>
                      {whatsapp.waName ? `${whatsapp.name} - ${whatsapp.waName}` :
                       whatsapp.name ? whatsapp.name :
                       `Conexión ${whatsapp.id}`}
                    </span>
                  </div>
                </div>
              );
            }}
          >
            <MenuItem value=""><span role="img" aria-label="No definido">❌</span> {i18n.t("campaigns.placeholders.notDefinedMale")}</MenuItem>
            {whatsapps &&
              whatsapps.map((whatsapp) => (
                <MenuItem dense key={whatsapp.id} value={whatsapp.id}>
                  <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <span style={{ marginRight: '8px', fontSize: '16px' }} role="img" aria-label="WhatsApp">📱</span>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                          {whatsapp.name || `Conexión ${whatsapp.id}`}
                        </span>
                        <span
                          style={{
                            fontSize: '10px',
                            padding: '2px 6px',
                            borderRadius: '10px',
                            backgroundColor: whatsapp.status === 'CONNECTED' ? '#25d366' : '#e1306c',
                            color: 'white',
                            fontWeight: 'bold'
                          }}
                        >
                          {whatsapp.status || 'DISCONNECTED'}
                        </span>
                      </div>
                      <span style={{ fontSize: '12px', color: '#666' }}>
                        {whatsapp.waName ? `${whatsapp.name} - ${whatsapp.waName}` :
                         whatsapp.name ? whatsapp.name :
                         `Conexión ${whatsapp.id}`}
                      </span>
                    </div>
                  </div>
                </MenuItem>
              ))}
          </Field>
        </FormControl>
      </Grid>
      <Grid xs={12} md={4} item>
        <DateTimePickerWithTimezone
          label={
            <span>
              <span role="img" aria-label="Fecha programada">📅</span> {
                // ✅ CORRECCIÓN: Para campañas RECURRENTES activas, mostrar "Próxima Ejecución"
                (values.tipo === 'RECURRENTE' || values.isRecurring) &&
                values.executionCount &&
                values.executionCount > 0 &&
                (values.status === 'PROGRAMADA' || values.status === 'ACTIVA')
                  ? "Próxima Ejecución"
                  : i18n.t("campaigns.dialog.form.scheduledAt")
              }
            </span>
          }
          value={values.scheduledAt || null}
          onChange={(newValue) => {
            // ✅ OPCIÓN 1: Actualizar el campo inmediatamente sin validar (evita confusión mientras edita)
            // La validación se hará en onBlur cuando el usuario termine de editar
            setFieldValue('scheduledAt', newValue || "");
            setCampaign((prev) => ({ ...prev, scheduledAt: newValue || "" }));

            // ✅ CORRECCIÓN: Limpiar error de nombre duplicado cuando el usuario cambia la fecha/hora
            if (errorMessage && (errorMessage.includes("nombre de campaña") || errorMessage.includes("ya existe"))) {
              setErrorMessage("");
              setErrorModalOpen(false);
            }
          }}
          onBlur={() => {
            // ✅ OPCIÓN 1: Validar solo cuando el usuario termina de editar (onBlur)
            // Esto evita validaciones confusas mientras el usuario está escribiendo
            const currentValue = values.scheduledAt;
            if (currentValue && currentValue !== "") {
              // ✅ CORRECCIÓN CRÍTICA: Usar getCampaignTimezoneSync() en lugar de localStorage.getItem("timezone")
              const campaignTimezone = getCampaignTimezoneSync();

              // Parsear en zona empresa para validaciones
              const selectedMoment = moment.tz(currentValue, 'YYYY-MM-DD HH:mm:ss', campaignTimezone);
              const nowInCompanyTimezone = moment().tz(campaignTimezone);
              const diffMinutes = selectedMoment.diff(nowInCompanyTimezone, 'minutes', true);

              // ✅ OPCIÓN 3: Mensaje más claro con ambas fechas visibles
              if (diffMinutes < -1) {
                // Fecha pasada - mostrar modal con mensaje mejorado
                const pastDiffMinutes = nowInCompanyTimezone.diff(selectedMoment, 'minutes');
                const formattedSelected = selectedMoment.format('DD/MM/YYYY HH:mm');
                const formattedNow = nowInCompanyTimezone.format('DD/MM/YYYY HH:mm');
                setDatePastMessage(
                  `La fecha seleccionada (${formattedSelected}) es anterior a la hora actual (${formattedNow}).\n\nDiferencia: ${pastDiffMinutes} minutos en el pasado.\n\n¿Desea actualizar la fecha a ahora mismo (hora actual + 2 minutos) para enviar la campaña inmediatamente?`
                );
                setPendingSetFieldValue(() => setFieldValue);
                setDatePastModalOpen(true);
              } else if (diffMinutes > 0 && diffMinutes < 10) {
                // ✅ REGLA DE NEGOCIO: Fecha futura pero < 10 minutos - mostrar modal informativo
                const formattedDate = selectedMoment.format('DD/MM/YYYY HH:mm');
                setShortTimeMessage(
                  `La fecha programada (${formattedDate}) está a menos de 10 minutos (${Math.ceil(diffMinutes)} minutos). Si programa con menos de 10 minutos, no tendrá opción a modificar esta campaña ya que los tiempos son muy cortos para su procesamiento. Se sugiere programar envíos mayores a 30 minutos.`
                );
                setPendingSetFieldValue(() => setFieldValue);
                setPendingScheduledAt(currentValue);
                setShortTimeModalOpen(true);
              }
            }
          }}
          timezone={companyTimezone || getCampaignTimezoneSync()}
          error={touched.scheduledAt && Boolean(errors.scheduledAt)}
          helperText={
            touched.scheduledAt && errors.scheduledAt
              ? errors.scheduledAt
              : (values.tipo === 'RECURRENTE' || values.isRecurring) &&
                values.executionCount &&
                values.executionCount > 0 &&
                values.originalScheduledAt
                  ? `Primera ejecución: ${moment.tz(values.originalScheduledAt, 'YYYY-MM-DD HH:mm:ss', getCampaignTimezoneSync()).format('DD/MM/YYYY HH:mm')}`
                  : undefined
          }
          disabled={!campaignEditable}
          minDate={(() => {
            // Calcular fecha mínima en zona empresa
            const tz = companyTimezone || getCampaignTimezoneSync();
            const nowInCompanyTimezone = moment().tz(tz);
            // Extraer valores para crear Date "falso"
            const year = nowInCompanyTimezone.year();
            const month = nowInCompanyTimezone.month();
            const day = nowInCompanyTimezone.date();
            const hour = nowInCompanyTimezone.hour();
            const minute = nowInCompanyTimezone.minute();
            return new Date(year, month, day, hour, minute);
          })()}
        />
      </Grid>
      <Grid xs={12} md={4} item>
        <FormControl
          variant="outlined"
          margin="dense"
          className={`${classes.FormControl} ${classes.selectField}`}
          fullWidth
        >
          <InputLabel id="fileListId-selection-label"><span role="img" aria-label="Lista de archivos">📁</span> {i18n.t("campaigns.dialog.form.fileList")}</InputLabel>
          <Field
            as={Select}
            label={
              <span>
                <span role="img" aria-label="Lista de archivos">📁</span> {i18n.t("campaigns.dialog.form.fileList")}
              </span>
            }
            name="fileListId"
            id="fileListId"
            placeholder={i18n.t("campaigns.dialog.form.fileList")}
            labelId="fileListId-selection-label"
            value={values.fileListId || ""}
            disabled={Boolean(isAttachmentSelected) || !campaignEditable}
            onChange={(e) => handleFileListChange(e.target.value, setFieldValue)}
          >
            <MenuItem value={""}><span role="img" aria-label="No definido">❌</span> {i18n.t("campaigns.placeholders.notDefinedMale")}</MenuItem>
            {fileLists.map(f => (
              <MenuItem key={f.id} value={f.id}>
                <span role="img" aria-label="Archivo">📁</span> {f.name}
              </MenuItem>
            ))}
          </Field>
        </FormControl>
      </Grid>
      {/* Grid independiente para el mensaje de total de contactos - Ubicado después de Lista de Archivos */}
      <Grid xs={12} md={4} item>
        {selectedContactListCount !== null && values.contactListId && values.contactListId !== "" && (
          <Typography
            variant="body2"
            style={{
              marginTop: '8px',
              color: '#d32f2f',
              fontWeight: 'bold',
              fontSize: '0.875rem',
              padding: '8px 0'
            }}
          >
            TOTAL MENSAJES A ENVIAR DE LA LISTA "{contactLists.find(list => list.id === parseInt(values.contactListId))?.name || ''}" ES {selectedContactListCount}
          </Typography>
        )}
      </Grid>

      {/* ✅ FASE 4: TABS PRINCIPALES SEGÚN TIPO DE CAMPAÑA */}
      <Grid xs={12} item>
        <Divider style={{ margin: '20px 0' }} />
        <Tabs
          value={configTab}
          indicatorColor="primary"
          textColor="primary"
          onChange={(e, v) => setConfigTab(v)}
          variant="fullWidth"
          centered
          style={{
            borderRadius: 2,
            marginBottom: 20,
          }}
        >
          {currentCampaignType === 'RECURRENTE' && (
            <Tab label={<><span role="img" aria-label="Recurrencia">🔄</span> RECURRENCIA</>} />
          )}
          <Tab
            label={
              <>
                <span role="img" aria-label={campaignAiChoice === "yes" ? i18n.t("campaigns.dialog.ai.ariaAiEnvironment") : "Mensaje"}>
                  {campaignAiChoice === "yes" ? "✨" : "💬"}
                </span>{" "}
                MENSAJE
              </>
            }
          />
          <Tab label={<><span role="img" aria-label="Intervalo">⏱️</span> INTERVALO</>} />
          <Tab label={<><span role="img" aria-label="Etiquetado">🏷️</span> ETIQUETADO</>} />
          {campaignAiChoice === "yes" && (
            <Tab
              label={
                <>
                  <span role="img" aria-label={i18n.t("campaigns.dialog.ai.ariaAiEnvironment")}>
                    🤖
                  </span>{" "}
                  {i18n.t("campaigns.dialog.ai.responderTab")}
                </>
              }
            />
          )}
        </Tabs>
      </Grid>
    </>
  );
};

export default CampaignFormHeader;
